import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
	gap: 20px;
	margin: 0 0 0 10px;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
`;

export const Item = styled.div`
	background-color: ${tokens.color_gray_light};
	border-radius: 6px;
	color: ${tokens.color_gray_dark};
	display: flex;
	justify-content: space-between;
	padding: 10px 15px;
	cursor: pointer;
`;

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
`;
